function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable jsx-a11y/anchor-is-valid, no-script-url */
import _map from 'lodash/map';
import _omit from 'lodash/omit';
import React from 'react';
import PropTypes from 'prop-types';

var LocalizationDropdown =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LocalizationDropdown, _React$Component);

  function LocalizationDropdown(props) {
    var _this;

    _classCallCheck(this, LocalizationDropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LocalizationDropdown).call(this, props));
    _this._renderLanguageListItem = _this._renderLanguageListItem.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(LocalizationDropdown, [{
    key: "_renderLanguageListItem",
    value: function _renderLanguageListItem(languageName, languageCode) {
      return React.createElement("li", {
        key: "language-list-item-".concat(languageCode)
      }, React.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.languageListItemOnClickGenerator(languageCode)
      }, this.constructLanguageString(languageName, languageCode)));
    }
  }, {
    key: "languageListItemOnClickGenerator",
    value: function languageListItemOnClickGenerator(languageCode) {
      var _this2 = this;

      return function () {
        _this2.props.updateCurrentLanguage(languageCode);

        window.location.reload(); // TODO: this is not ideal
      };
    }
  }, {
    key: "dropdownClasses",
    value: function dropdownClasses() {
      var classes = ['navigation-bar__localization-dropdown dropdown'];
      if (this.props.dark) classes.push('navigation-bar__localization-dropdown--dark');
      return classes.join(' ');
    }
  }, {
    key: "constructLanguageString",
    value: function constructLanguageString(languageName, languageCode) {
      if (this.props.isMobileWidth) return languageName;
      return "".concat(languageName, " (").concat(languageCode, ")");
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: this.dropdownClasses()
      }, React.createElement("button", {
        className: "navigation-bar__localization-dropdown__button btn btn-default dropdown-toggle",
        type: "button",
        id: "localization-dropdown",
        "data-toggle": "dropdown"
      }, this.constructLanguageString(this.props.supportedLanguageMap[this.props.currentLanguage], this.props.currentLanguage), ' ', React.createElement("span", {
        className: "caret"
      })), React.createElement("ul", {
        className: "dropdown-menu"
      }, _map(_omit(this.props.supportedLanguageMap, this.props.currentLanguage), this._renderLanguageListItem)));
    }
  }]);

  return LocalizationDropdown;
}(React.Component);

LocalizationDropdown.propTypes = {
  dark: PropTypes.bool,
  isMobileWidth: PropTypes.bool.isRequired,
  currentLanguage: PropTypes.string.isRequired,
  supportedLanguageMap: PropTypes.object.isRequired,
  updateCurrentLanguage: PropTypes.func.isRequired
};
export { LocalizationDropdown as default };